module.exports = __webpack_public_path__ + "img/shape-5-mobile-gold@2x.996cd7f6.png";